import { render } from "./notfound.vue?vue&type=template&id=69387374&scoped=true"
import script from "./notfound.vue?vue&type=script&lang=js"
export * from "./notfound.vue?vue&type=script&lang=js"

import "./notfound.vue?vue&type=style&index=0&id=69387374&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69387374"]])

export default __exports__